import { render, staticRenderFns } from "./RelatedMap.vue?vue&type=template&id=e04a4f10&scoped=true&"
import script from "./RelatedMap.vue?vue&type=script&lang=js&"
export * from "./RelatedMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04a4f10",
  null
  
)

export default component.exports